module.exports = "/static/fonts/OpenSans-BoldItalic.woff2";